import Noticias from "views/Noticias/Noticias";
import Perfil from "views/Perfil/Perfil";
import ChangePass from "views/Perfil/ChangePass";
import MainEmail from "views/Email/MainEmail";
import PefilesPendientes from "views/Perfil/PefilesPendientes";
import InscripcionesPendientes from "views/Inscripcion/InscripcionesPendientes";
import MainPublicaciones from "views/Publicaciones/MainPublicaciones";
import MainRegistros from "views/Registros/MainRegistros";
import MainSecciones from "views/Secciones/MainSecciones";
import MainAcademicos from "views/Academicos/MainAcademicos";
/* import MainAcademicosEst from "views/EstAcademicos/MainAcademicosEst"; */
import MainConsultasEst from "views/EstConsultas/MainConsultasEst";
import MainSolicitudesEst from "views/EstSolicitudes/MainSolicitudesEst";
import MainReportes from "views/Reportes/MainReportes";


import MainAcademicosProf from "views/ProfAcademicos/MainAcademicosProf";
import MainMisAulas from "views/ProfAulas/MainMisAulas";


import Inscripcion from "views/Inscripcion/Inscripcion";
import Admision from "views/Admision/Admision";
import Reinscripciones from "views/Administracion/Reinscripciones";
import AdmisionAdmin from "views/AdmisionAdmin/AdmisionAdmin";
import EstadoDeCuenta from "views/EstAdmin/EstadoDeCuenta";

import MainEstadoDeCuenta from "views/Administracion/MainEstadoDeCuenta";
import AdminSolicitudes from "views/Administracion/AdminSolicitudes";
import ControlDeIngresos from "views/Administracion/ControlDeIngresos";
import Cobranzas from "views/Administracion/Cobranzas";

import MainRegistrosAdmin from "views/Registros/MainRegistrosAdmin";
import OpcionesAdmin from "views/Opciones/OpcionesAdmin";
import BienestarMain from "views/Bienestar/BienestarMain";
import MainEnvios from "views/Envios/MainEnvios";

import EditInicio from "views/WebMaster/EditInicio";
import EditInstitucion from "views/WebMaster/EditInstitucion";
import EditGrafico from "views/WebMaster/EditGrafico";
import EditInterior from "views/WebMaster/EditInterior";
import EditModa from "views/WebMaster/EditModa";
import EditPublicidad from "views/WebMaster/EditPublicidad";
import EditIngreso from "views/WebMaster/EditIngreso";
import EditExtension from "views/WebMaster/EditExtension";
import EditEventos from "views/WebMaster/EditEventos";
import EditContacto from "views/WebMaster/EditContacto";

import MainConsultas from "views/Consultas/MainConsultas";

const dashboardRoutes = [
  {
    path: "/perfil",
    name: "Perfil",
    icon: "",
    component: Perfil,
    type: 1
  },
  {
    path: "/change_pass",
    name: "ChangePass",
    icon: "",
    component: ChangePass,
    type: 1
  },
  {
    path: "/noticias",
    name: "Noticias",
    icon: "pe-7s-news-paper",
    component: Noticias,
    type: 1
  },
  {
    path: "/email",
    name: "MainEmail",
    icon: "",
    component: MainEmail,
    type: 1
  },


  {
    path: "/perfiles_pendientes",
    name: "PefilesPendientes",
    icon: "",
    component: PefilesPendientes,
    type: 2
  },
  {
    path: "/inscripciones_pendientes",
    name: "InscripcionesPendientes",
    icon: "",
    component: InscripcionesPendientes,
    type: 2
  },
  {
    path: "/registros",
    name: "MainRegistros",
    icon: "",
    component: MainRegistros,
    type: 2
  },
  {
    path: "/publicaciones",
    name: "Publicaciones",
    icon: "",
    component: MainPublicaciones,
    type: 2
  },
  {
    path: "/secciones",
    name: "MainSecciones",
    icon: "",
    component: MainSecciones,
    type: 2
  },
  {
    path: "/academicos",
    name: "MainAcademicos",
    icon: "",
    component: MainAcademicos,
    type: 2
  },
  {
    path: "/reportes",
    name: "MainReportes",
    icon: "",
    component: MainReportes,
    type: 2
  },

  {
    path: "/prof_academicos",
    name: "Academicos",
    icon: "",
    component: MainAcademicosProf,
    type: 3
  },
  {
    path: "/prof_aulas",
    name: "Mis Aulas",
    icon: "",
    component: MainMisAulas,
    type: 3
  },
  {
    path: "/email",
    name: "MainEmail",
    icon: "",
    component: MainEmail,
    type: 3
  },

  /* {
    path: "/admision",
    name: "Admisión",
    icon: "",
    component: Admision,
    type: 4
  }, */
  {
    path: "/admision",
    name: "Admisión",
    icon: "",
    component: Perfil,
    type: 4
  },
  {
    path: "/inscripcion",
    name: "Inscripcion",
    icon: "",
    component: Inscripcion,
    type: 4
  },
/*   {
    path: "/academicos",
    name: "Academicos",
    icon: "",
    component: MainAcademicosEst,
    type: 4
  }, */
  {
    path: "/est_consultas",
    name: "Consultas",
    icon: "",
    component: MainConsultasEst,
    type: 4
  },
  {
    path: "/est_solicitudes",
    name: "Consultas",
    icon: "",
    component: MainSolicitudesEst,
    type: 4
  },
  {
    path: "/cuenta",
    name: "Estado de Cuenta",
    icon: "",
    component: EstadoDeCuenta,
    type: 4
  },

  {
    path: "/publicaciones",
    name: "Publicaciones",
    icon: "",
    component: MainPublicaciones,
    type: 5
  },
  {
    path: "/registros_admin",
    name: "Registros",
    icon: "",
    component: MainRegistrosAdmin,
    type: 5
  },
  {
    path: "/admision_admin",
    name: "Admisiones",
    icon: "",
    component: AdmisionAdmin,
    type: 5
  },
  {
    path: "/reincripciones",
    name: "Reinscripciones",
    icon: "",
    component: Reinscripciones,
    type: 5
  },
  {
    path: "/estados_de_cuenta",
    name: "Estados de Cuenta",
    icon: "",
    component: MainEstadoDeCuenta,
    type: 5
  },
  {
    path: "/admin_solicitudes",
    name: "Solicitudes",
    icon: "",
    component: AdminSolicitudes,
    type: 5
  },
  {
    path: "/ingresos",
    name: "Ingresos",
    icon: "",
    component: ControlDeIngresos,
    type: 5
  },
  {
    path: "/cobranzas",
    name: "Cobranzas",
    icon: "",
    component: Cobranzas,
    type: 5
  },
  {
    path: "/preferencias_admin",
    name: "Opciones",
    icon: "",
    component: OpcionesAdmin,
    type: 5
  },
  {
    path: "/bienestar_estudiantil",
    name: "Bienestar Est.",
    icon: "",
    component: BienestarMain,
    type: 5
  },
  {
    path: "/notificaciones",
    name: "Notificaciones",
    icon: "",
    component: MainEnvios,
    type: 5
  },

  {
    path: "/edit_home",
    name: "Inicio",
    icon: "",
    component: EditInicio,
    type: 6
  },
  {
    path: "/edit_institucion",
    name: "La Institución",
    icon: "",
    component: EditInstitucion,
    type: 6
  },
  {
    path: "/edit_grafico",
    name: "Diseño Gráfico",
    icon: "",
    component: EditGrafico,
    type: 6
  },
  {
    path: "/edit_interior",
    name: "Diseño Interior",
    icon: "",
    component: EditInterior,
    type: 6
  },
  {
    path: "/edit_moda",
    name: "Diseño de Moda",
    icon: "",
    component: EditModa,
    type: 6
  },
  {
    path: "/edit_publicidad",
    name: "Publicidad y Merc.",
    icon: "",
    component: EditPublicidad,
    type: 6
  },
  {
    path: "/edit_ingreso",
    name: "Ingreso",
    icon: "",
    component: EditIngreso,
    type: 6
  },
  {
    path: "/edit_extension",
    name: "Extensión",
    icon: "",
    component: EditExtension,
    type: 6
  },
  {
    path: "/edit_eventos",
    name: "Eventos",
    icon: "",
    component: EditEventos,
    type: 6
  },
  {
    path: "/edit_contacto",
    name: "Contacto",
    icon: "",
    component: EditContacto,
    type: 6
  },
  {
    path: "/consultas",
    name: "Consultas",
    icon: "",
    component: MainConsultas,
    type: 7
  },
  {
    path: "/perfiles_pendientes",
    name: "PefilesPendientes",
    icon: "",
    component: PefilesPendientes,
    type: 7
  },
  { redirect: true, path: "/noticias", to: "/", name: "Noticias", type: 1 }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx